import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { authAtom } from "stores";
import { useSetRecoilState } from "recoil";

import { onVerifyCodeResponse } from "./helper";

const verifyCode = async (data: VerifyCodeReqT) =>
  axios.post(Routes.VERIFY_CODE, data);

export const useVerifyCode = () => {
  const setAuth = useSetRecoilState(authAtom);

  return useMutation({
    mutationKey: [Keys.VERIFY_CODE_MUT],
    mutationFn: verifyCode,
    onSuccess: (res) => {
      onVerifyCodeResponse({ auth: res.data, setAuth });
      return res;
    },
  });
};
